module.exports = __webpack_public_path__ + "static/media/ouch.f89348df.jpg";